import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		wrapper: 'justify-center bg-black',
		base: 'flex flex-col lg:grid grid-cols-6 gap-x-4 lg:max-w-[172rem] px-2 md:px-4 mx-auto py-5 md:py-[10rem]',
		content: 'col-span-2 h-full flex flex-col',
		list: 'col-span-4 flex max-xl:flex-col xl:flex-wrap space-y-[1.5rem] xl:space-y-0 mt-2 lg:mt-0 xl:ml-6',
		listItem: 'flex border border-white rounded-[0.8rem] xl:w-1/2',
		legendWrapperDesktop: 'hidden lg:block lg:mt-auto',
		legendWrapperMobile: 'lg:hidden mt-4',
		formDesktop: 'hidden lg:block lg:mb-7',

		legendsDesktop: 'flex space-x-4 px-[2.6rem] py-2 border border-white rounded-[0.8rem] mt-1',
		legendsMobile: 'flex flex-col space-y-2 p-2 border border-white rounded-[0.8rem] mt-1',
		legendStyle: 'flex items-center space-x-1',
		legendLogo: 'h-[1.6rem] w-[1.6rem]',
	},
	variants: {
		moreElements: {
			true: {
				content: 'xl:sticky xl:top-[12rem] xl:h-[calc(100vh-20rem)]',
				list: 'flex-col xl:space-y-3',
				listItem: 'xl:rounded-m xl:w-full',
			},
			false: {
				list: 'xl:gap-y-0 xl:grid-cols-2 xl:rounded-m xl:border xl:border-white',
				listItem: 'xl:rounded-none xl:border-0 xl:[&:nth-of-type(-n+2)]:border-b xl:[&:nth-of-type(odd)]:border-r',
			},
		},
	},
})

export type ASectionVariants = VariantProps<typeof styles>
